<template>
  <RallyNav v-if="!this.$refs.RallyNav"/>
  <div>
    <main :class="[channelSlug, 'index']">
      <div>
        <!-- In MembersPage.vue template -->
          <InvitationDrawer
              :key="drawerKey"
              :state="invitationDrawerState"
              :rallyId="rallyId"
              :emailToInvite="emailToInvite"
              :firstNameToInvite="firstNameToInvite"
              :lastNameToInvite="lastNameToInvite"
              :isDirectInvite="isDirectInvite"
              @close="toggleInvitationDrawer"
          />
      </div>
      <ToolBar :options="toolbarOptions" allow-member-filter="true" v-on:perform="perform" />
      <MembersComponent :rally="rally" :channel="channel" ref="memComp"/>
    </main>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import {RCS_REPORTS_URL, RMEMS_REPORTS_URL, router} from "../common";
import { findDefaultChannelOfType, getChannelSlug } from "../common";
import InvitationDrawer from "@/components/InvitationDrawer.vue";
import {eventBus} from "@/main";
import axios from "axios";
import {userInfo} from "@/common/user-info";
export default {
  components: {
    InvitationDrawer,
  },
  props: ["channel", "rally"],
  data: function() {
    return {
      invitationDrawerState: false,
      emailToInvite: "",
      firstNameToInvite: "",
      lastNameToInvite: "",
      drawerKey: 0,
      isDirectInvite: false // New property to track if it's a direct invite
    };
  },
  computed: {
    ...mapState("memberships", ["membersByRallyId", "membersFilter" ]),
    ...mapState("user", ["usersById"]),
    ...mapState("rallies", ["allRalliesByRallyId"]),

    channelSlug() {
      // Used in place of channel.type.
      return getChannelSlug(this.$route)
    },
    members() {
      return this.membersByRallyId[this.rallyId];
    },
    rallyId() {
      return this.rally.id;
    },
    selectedRally: function() {
      return this.rally;
    },
    toolbarOptions() {
      let options = new Array();

      // Disable console errors for using TRUE and FALSE in examples.
      /* eslint-disable no-constant-condition */

      // Consult rally.privacy
      /*
      not mvp
      if (true) {
        options.push({ click: "foo", icon: "fa-plus-circle", label: "Invite" });
      }
      */
      // Present for everyone
      options.push({ onClick: "openSearch", params: { context: 'members' }, icon: "fa-search", label: "Search" });
      options.push({ onClick: "refreshDir", params: { }, icon: "fa-sync", label: "Refresh" });
      if (this.selectedRally.attributes.editable) {
        options.push({ onClick: "openSettings", params: { context: 'directory' }, icon: "fa-cog", label: "Settings" });
        options.push({ onClick: "downloadList", params: { context:  "Members"}, icon: "fa-download", label: "Download", permission:"writable" });
        options.push({ onClick: "toggleInvitationDrawer", params: { context: 'directory' }, icon: "fa-user-plus", label: "Invite Friends" });
    }

      //not mvp
      //options.push({ click: "foo", icon: "fa-star", label: "Owner & Admin" });

      // This should only be true for rally admin.
      /*
      not mvp
      if (true) {
        options.push({ click: "foo", icon: "fa-cog", label: "Settings" });
      }
      */
      return options;
    }
  },
  created() {
    eventBus.on('inviteUserEvent', (email) => {
      this.openInvitationDrawerWithEmail(email);
    });

    eventBus.on('download', () => {
      this.downloadList();
      //alert('here')
    })
  },
  methods: {
    ...mapActions("memberships", ["fetchMembersByRally", "clearMemberState", "setMembersFilter"]),
    log(message) {
      this.$log.debug(message);
    },
    downloadList() {
      const token = localStorage.getItem('at');

      axios({
        url: RMEMS_REPORTS_URL() + "?report_name=member_list"
            + "&rally_id="
            + this.rallyId,
        method: 'GET',
        responseType: 'blob', // Set the response type to 'blob' for file download
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'text/csv',
          'Accept': 'text/csv'
        },
      })
          .then(response => {
            // Create a temporary anchor element
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', this.rallyId + '_members.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch(error => {
            console.error('Error downloading file:', error);
          });
    },
    /*handleMemberFilterChange(status) {
      if (status === 'only_friends') {
        this.$refs.memComp.refreshMembers( ['Friend', 'Subscriber'], ["Active"])
      } else if (status == 'admins') {
        this.$refs.memComp.refreshMembers( ['Owner', 'Admin'], ["Active"])
      } else if (status == 'all_members') {
        this.$refs.memComp.refreshMembers( ['Owner', 'Admin', 'Friend', 'Subscriber'], ["Active", "Invited", "Requested"])
      } else if (status == 'all_members_and_declinees') {
        this.$refs.memComp.refreshMembers( ['Owner', 'Admin', 'Friend', 'Subscriber'], ["Active", "Invited", "Declined", "Requested", "Pending"])
      } else if (status == 'declinees') {
        this.$refs.memComp.refreshMembers( ['Owner', 'Admin', 'Friend', 'Subscriber'], ["Declined"])
      } else if (status == 'invitees') {
        this.$refs.memComp.refreshMembers( ['Owner', 'Admin', 'Friend', 'Subscriber'], ["Invited"])
      } else if (status == 'requestees') {
        this.$refs.memComp.refreshMembers( ['Owner', 'Admin', 'Friend', 'Subscriber'], ["Requested"])
      } else if (status == 'pending') {
        this.$refs.memComp.refreshMembers( ['Owner', 'Admin', 'Friend', 'Subscriber'], ["Pending"])
      }
    },*/
    async handleMemberFilterChange(status) {
      await this.setMembersFilter({"membersFilter": status})
      this.$refs.memComp.refreshMembersByStatus()
    },
    openInvitationDrawerWithEmail(userData) {
      // First make sure everything is closed
      this.invitationDrawerState = false;

      // Update the user data
      this.emailToInvite = userData.email;
      this.firstNameToInvite = userData.firstName;
      this.lastNameToInvite = userData.lastName;
      this.isDirectInvite = true; // Mark as direct invite

      // Increment the key to force component re-creation
      this.drawerKey++;

      // Scroll to the top of the page
      window.scrollTo({ top: 0, behavior: 'smooth' });

      // Force a small delay to ensure Vue updates the component
      setTimeout(() => {
        this.invitationDrawerState = true;
      }, 50);
    },
    refreshDir(){
      this.$refs.memComp.refreshMembers();
    },
    closeAllDrawers() {
      // Set state to false
      this.invitationDrawerState = false;

      // Manually close all drawers in DOM
      const allDrawers = document.querySelectorAll('#header-invitation');
      allDrawers.forEach(drawer => {
        drawer.classList.remove('expanded');
      });

      // Reset user data
      this.emailToInvite = "";
      this.firstNameToInvite = "";
      this.lastNameToInvite = "";
    },
    toggleInvitationDrawer() {
      if (this.invitationDrawerState) {
        // If we're closing, reset everything
        this.invitationDrawerState = false;
        this.emailToInvite = "";
        this.firstNameToInvite = "";
        this.lastNameToInvite = "";
        this.isDirectInvite = false;
      } else {
        // If we're opening from the toolbar button, it's not a direct invite
        this.isDirectInvite = false;
        this.invitationDrawerState = true;
      }
    },
// In the perform method in MembersPage.vue
    perform(method, params) {
      if (method === "toggleInvitationDrawer") {
        // If it's currently closed, just open it
        if (!this.invitationDrawerState) {
          this.invitationDrawerState = true;
        } else {
          // If it's open, close it
          this.toggleInvitationDrawer();
        }
      } else {
        params ? this[method](params) : this[method]();
      }
    },
  }
};
</script>
